import { render, staticRenderFns } from "./logs-tab.vue?vue&type=template&id=60d92fc5"
import script from "./logs-tab.vue?vue&type=script&lang=js"
export * from "./logs-tab.vue?vue&type=script&lang=js"
import style0 from "./logs-tab.vue?vue&type=style&index=0&id=60d92fc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports